<template>
  <body class="main-body">
    <div class="flex-container">
      <!-- header -->
      <div class="company-header" v-if="user_data">
        <div class="left-box">
          <p class="-company">{{ user_info.company_name }}</p>
          <p class="-name">{{ user_info.user_name }} 様</p>
        </div>
      </div>
      <div class="company-header" v-else>
        <div class="left-box">
          <p class="-company">---</p>
          <p class="-name">--- 様</p>
        </div>
      </div>
      <!-- ログイン状態リセット -->
      <div class="main-container">
        以下のボタンをクリックすると、ログイン状態がリセットされます。
        リセット後、自動でログイン画面に遷移します。
        <br><br>
        <a class="button" @click="sendLoginReset()">ログイン状態リセット</a>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  computed: {
    user_info () {
      if (this.user_data) {
        return this.user_data
      } else {
        return {
          company_name: '不明',
          user_name: '不明ユーザー',
          user_id: '',
        }
      }
    },
  },
  props: {
    user_id: {
      type: String,
      default: '',
      required: true
    }
  },
  data () {
    return {
        user_data: null
    }
  },
  mounted () {
    // ユーザー情報取得
    this.$store.dispatch('auth/getLoginResetUser', this.user_id)
      .then((user_data) => {
          this.user_data = user_data
      })
      .catch(() => {
        alert('ログイン状態リセット対象のユーザー情報取得に失敗しました。')
      })
  },
  methods: {
    sendLoginReset() {
      const payload = {
        user_id : this.user_id
      }
      this.$store.dispatch('auth/login_reset', payload)
      .then((result) => {
        if (result) {
          // ログイン画面に遷移
          this.$router.push('/login')
        } else {
          alert('ログイン状態のリセットに失敗しました。')
        }
      })
      .catch(() => {
        alert('ログイン状態のリセットに失敗しました。')
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
html, body, .main-body {
  width: 100vw;
  height: 100vh !important;
  max-width: 500px;
  overflow: hidden !important;
  margin: 0 auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.flex-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 252px);
  position: relative;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.loading-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.entry {
  font-weight: bold;
}
.button-wrapper {
  .button {
    margin-top: 24px;
    width: 160px;
  }
}
.company-header{
  background: #f8f8f8;
  height: 72px;
  padding: 4px 24px;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
  .-name {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
  }
  .-company {
    text-align: left;
    font-size: 13px;
  }
}
.chat-dialog {
  height: 100%;
  scroll-behavior: smooth;
  background-color: #fff;
}
.chat-scroll {
  overflow: scroll !important;
}
.chat-scroll::-webkit-scrollbar {
  width:  15px !important;
}
.input-button {
  background: transparent;
  border: none;
  resize: none;
  outline:none;
}

.parent-form {
  width: 100%;
  background: #F8F8F8;
  border-top: solid thin #CCC;
}
.child-form {
  text-align: center;
  padding-bottom: 0px !important;
  min-height: 45px;
  background: #F8F8F8;
}
textarea {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
  line-height: 25px;
  padding-top: 10px;
  padding-left: 8px;
}
.loading-form {
  height: 20px;
  background-color: transparent;
  font-size: 16px;
}
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  margin-left: 10px;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
.loading span:nth-child(4) {
  animation-delay: .3s;
}
.loading span:nth-child(5) {
  animation-delay: .4s;
}
.loading span:nth-child(6) {
  animation-delay: .5s;
}
.loading span:nth-child(7) {
  animation-delay: .6s;
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
.list {
  height: 80vh;
}
.chat-list-enter-active, .chat-list-leave-active {
  transition: all 1s;
}
.chat-list-enter, .chat-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.mogomogo-enter-active, .mogomogo-leave-active {
  transition: all 1s;
}
.mogomogo-enter, .mogomogo-leave-to {
  position: absolute;
  transform: scale(0);
}
.huyuu {
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}
.footer-area {
  display: flex;
  justify-content: space-between;
}
.left-block, .right-block {
  width: 96px;
}
.center-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
.auto-button {
  border-radius: 16px;
}
.tap-box {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  margin: auto;
  height: 160px;
}
.auto-button-wrapper {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
.workday-tooltip{
  position : relative;
  cursor   : pointer;
  display  : inline-block;
}
.tooltip-workday-message {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 12px;
  border-radius : 5px;
  width         : 200px;
  z-index       : 10;
  text-align: center;
}
.tooltip-workday-message:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 10px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.workday-tooltip:hover .tooltip-workday-message{
  display : inline-block;
  top     : 34px;
  left    : -15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login/LoginReset.vue